const showProfessionalServices = (industryType: string): boolean => {
  switch (industryType) {
    case "AGRICULTURE, FORESTRY AND FISHING":
    case "FINANCIAL AND INSURANCE SERVICES":
    case "HEALTH CARE AND SOCIAL ASSISTANCE":
    case "PROFESSIONAL, SCIENTIFIC AND TECHNICAL SERVICES":
      return true;
    default:
      return false;
  }
};

export { showProfessionalServices };
